const Index = resolve => require(['../views/home.vue'], resolve);
const NotFoundComponent = resolve => require(['../components/NotFoundComponent.vue'], resolve);//404页面
const search = resolve => require(['../views/search.vue'], resolve); //全局搜索

//票务预约
const ticketApply = resolve => require(['../views/appointment/ticket_apply.vue'], resolve); //票务预约
const chooseDate = resolve => require(['../views/appointment/chooseDate.vue'], resolve); //选择日期
const fillInfo = resolve => require(['../views/appointment/fillInfo.vue'], resolve); //填写个人信息
const confirmInfo = resolve => require(['../views/appointment/confirmInfo.vue'], resolve); //确认信息
const complete = resolve => require(['../views/appointment/complete.vue'], resolve); //完成预约

//改扩建、党政务公开
const extendPro = resolve => require(['../views/appointment/extend_pro.vue'], resolve); //改扩建工程
const goverPublic = resolve => require(['../views/appointment/gover_public.vue'], resolve); //党政务公开

//文博快讯
const newsList = resolve => require(['../views/news/newsList.vue'], resolve); //文博快讯
const noticeList = resolve => require(['../views/news/noticeList.vue'], resolve); //相关公告
const news_notice_detail = resolve => require(['../views/news/news_notice_detail.vue'], resolve); //活动详情

//藏博概况
const history = resolve => require(['../views/abstract/history.vue'], resolve); //历史沿革
const organization = resolve => require(['../views/abstract/organization.vue'], resolve); //机构设置
const speech = resolve => require(['../views/abstract/speech.vue'], resolve); //馆长致辞
const bigEvent = resolve => require(['../views/abstract/bigEvent.vue'], resolve); //大事记

//展览展讯
const exhibitHome = resolve => require(['../views/Exhibitions/exhibitHome.vue'], resolve); //展览展讯主页
const exhibitList = resolve => require(['../views/Exhibitions/exhibitList.vue'], resolve); //展览展讯列表
const exDetail = resolve => require(['../views/Exhibitions/exhibitDetail.vue'], resolve); //展览展讯详情
const allsence = resolve => require(['../views/Exhibitions/allsence.vue'], resolve); //全景漫游
const allsenceList = resolve => require(['../views/Exhibitions/allsenceList.vue'], resolve); //全景漫游列表

//臧品欣赏
const treasures = resolve => require(['../views/goodsEnjoy/treasures.vue'], resolve); //珍品欣赏
const fastLook = resolve => require(['../views/goodsEnjoy/fastLook.vue'], resolve); //文物快览
const collection = resolve => require(['../views/goodsEnjoy/collection.vue'], resolve); //征集捐献
const collectionList = resolve => require(['../views/goodsEnjoy/collectionList.vue'], resolve); //征集捐献列表
const exhibitsList = resolve => require(['../views/goodsEnjoy/exhibitsList.vue'], resolve); //展览文物
const exhibitsDetail = resolve => require(['../views/goodsEnjoy/exhibitsDetail.vue'], resolve); //展品详情
const solicitation = resolve => require(['../views/goodsEnjoy/solicitation.vue'], resolve); //登记藏品

//文创产品
const culturalHome = resolve => require(['../views/cultural/culturalHome.vue'], resolve); //文创精品
const culturalList = resolve => require(['../views/cultural/culturalList.vue'], resolve); //文创列表
const culturalNews = resolve => require(['../views/cultural/culturalNews.vue'], resolve); //文创动态
const culturalNewsList = resolve => require(['../views/cultural/culturalNewsList.vue'], resolve); //文创动态列表
const culturalNewsDetail = resolve => require(['../views/cultural/culturalNewsDetail.vue'], resolve); //文创动态详情

//教育活动
const educationHome = resolve => require(['../views/education/educationHome.vue'], resolve); //教育活动主页
const activityList = resolve => require(['../views/education/activityList.vue'], resolve); //最新活动
const activityDetail = resolve => require(['../views/education/activityDetail.vue'], resolve); //活动详情
const volunteers = resolve => require(['../views/education/volunteers.vue'], resolve); //志愿者之家
const volunteerActivityList = resolve => require(['../views/education/volunteerActivityList.vue'], resolve); //志愿者风采
const volunteerSignUp = resolve => require(['../views/education/volunteerSignUp.vue'], resolve); //志愿者报名

//问卷调查
const questionRadio = resolve => require(['../views/questionnaire/questionRadio.vue'], resolve); //问卷调查单选
const messageBoard = resolve => require(['../views/questionnaire/messageBoard.vue'], resolve); //留言板
const policies = resolve => require(['../views/questionnaire/policies.vue'], resolve); //政策法规
const mailbox = resolve => require(['../views/questionnaire/mailbox.vue'], resolve); //馆长信箱

//学术研究
const institutions = resolve => require(['../views/study/institutions.vue'], resolve); //学术机构
const magazine = resolve => require(['../views/study/magazine.vue'], resolve); //学术期刊
const classroom = resolve => require(['../views/study/classroom.vue'], resolve); //学术讲堂

//科技保护
const unitedStation = resolve => require(['../views/science/unitedStation.vue'], resolve); //联合工作站
const protection = resolve => require(['../views/science/protection.vue'], resolve); //保护修复成果
const protectionList = resolve => require(['../views/science/protectionList.vue'], resolve); //保护修复成果列表
const knowledge = resolve => require(['../views/science/knowledge.vue'], resolve); //科普知识
const knowledgeDetail = resolve => require(['../views/science/knowledgeDetail.vue'], resolve); //科普知识详情



export default [{
        path: '*',
        component: NotFoundComponent//全局404
    }, {
        path: '/',
        redirect: '/Index'
    },
    //************************* */
    {
        path: '/search',
        name: 'search',
        component: search,
    },
    //************************* */
    {
        path: '/Index',
        name: 'Index',
        component: Index,
    },
    //************************* */
    //文博资讯
    {
        path: '/newsList',
        name: 'newsList',
        component: newsList,
        meta: {
            title: 'home.MuseumNews', //文博快讯
            keepAlive: false
        },
    },
    {
        path: '/noticeList',
        name: 'noticeList',
        component: noticeList,
        meta: {
            title: 'home.Notice', //相关公告
            keepAlive: false
        },
    },
    {
        path: '/news_notice_detail',
        name: 'news_notice_detail',
        component: news_notice_detail,
        meta: {
            title: 'common.detailTitle', //资讯详情
            keepAlive: false
        },
    },
    //************************* */
    //票务预约、改扩建工程、党政务公开
    {
        path: '/ticketApply',
        name: 'ticketApply',
        component: ticketApply,
        meta: {
            title: 'appointment.title', //票务预约
            keepAlive: false
        },
    },
    {
        path: '/chooseDate', //选择日期
        name: 'chooseDate',
        component: chooseDate,
        meta: {
            title: 'appointment.title',
            keepAlive: false
        },
    },
    {
        path: '/fillInfo', //填写个人信息
        name: 'fillInfo',
        component: fillInfo,
        meta: {
            title: 'appointment.title',
            keepAlive: false
        },
    },
    {
        path: '/confirmInfo', //确认信息
        name: 'confirmInfo',
        component: confirmInfo,
        meta: {
            title: 'appointment.title',
            keepAlive: false
        },
    },
    {
        path: '/complete', //完成预约
        name: 'complete',
        component: complete,
        meta: {
            title: 'appointment.title',
            keepAlive: false
        },
    },
    {
        path: '/extendPro',
        name: 'extendPro',
        component: extendPro,
        meta: {
            title: 'home.expansionProject', //改扩建工程
            keepAlive: false
        },
    },
    {
        path: '/goverPublic',
        name: 'goverPublic',
        component: goverPublic,
        meta: {
            title: 'home.goverPublic', //党政务公开
            keepAlive: false
        },
    },
    //************************* */
    //臧博概况
    {
        path: '/history',
        name: 'history',
        component: history,
        meta: {
            title: 'menu.ab_history', //历史沿革
            keepAlive: false
        },
    }, {
        path: '/organization',
        name: 'organization',
        component: organization,
        meta: {
            title: 'menu.ab_structuring', //机构设置
            keepAlive: false
        },
    }, {
        path: '/speech',
        name: 'speech',
        component: speech,
        meta: {
            title: 'menu.ab_words', //馆长致辞
            keepAlive: false
        },
    }, {
        path: '/bigEvent',
        name: 'bigEvent',
        component: bigEvent,
        meta: {
            title: 'menu.ab_events', //大事记
            keepAlive: false
        },
    },
    //************************* */
    //文创产品
    {
        path: '/culturalHome',
        name: 'culturalHome',
        component: culturalHome,
        meta: {
            title: 'cultural.product', //文创产品主页
            keepAlive: false
        },
    },
    {
        path: '/culturalList',
        name: 'culturalList',
        component: culturalList,
        meta: {
            title: 'cultural.product', //文创列表
            keepAlive: false
        },
    },
    {
        path: '/culturalNews',
        name: 'culturalNews',
        component: culturalNews,
        meta: {
            title: 'cultural.product', //文创动态
            keepAlive: false
        },
    },
    {
        path: '/culturalNewsList',
        name: 'culturalNewsList',
        component: culturalNewsList,
        meta: {
            title: 'cultural.product', //文创动态列表
            keepAlive: false
        },
    },
    {
        path: '/culturalNewsDetail',
        name: 'culturalNewsDetail',
        component: culturalNewsDetail,
        meta: {
            title: 'cultural.product', //文创动态详情
            keepAlive: false
        },
    },

    //************************* */
    //展览展讯
    {
        path: '/exhibitHome',
        name: 'exhibitHome',
        component: exhibitHome,
        meta: {
            title: 'menu.exhibition',
            keepAlive: false
        },
    }, {
        path: '/exhibitList', //专题展览、特展回眸
        name: 'exhibitList',
        component: exhibitList,
        meta: {
            title: 'menu.exhibition', //展览展讯
            keepAlive: false
        },
    }, {
        path: '/exDetail',
        name: 'exDetail',
        component: exDetail,
        meta: {
            title: 'exhibition.detail', //展览详情
            keepAlive: false
        },
    }, {
        path: '/allsence',
        name: 'allsence',
        component: allsence,
        meta: {
            title: 'exhibition.allsence', //全景漫游
            keepAlive: false
        },
    }, {
        path: '/allsenceList',
        name: 'allsenceList',
        component: allsenceList,
        meta: {
            title: 'exhibition.allsence', //全景漫游列表
            keepAlive: false
        },
    },
    //************************* */
    //臧品欣赏
    {
        path: '/treasures',
        name: 'treasures',
        component: treasures,
        meta: {
            title: 'exhibits.treasure', //珍品赏析
            keepAlive: false
        },
    },
    {
        path: '/fastLook',
        name: 'fastLook',
        component: fastLook,
        meta: {
            title: 'exhibits.fastLook', //文物快览
            keepAlive: false
        },
    },
    {
        path: '/exhibitsList',
        name: 'exhibitsList',
        component: exhibitsList,
        meta: {
            title: '展览文物', //展览文物
            keepAlive: false
        },
    },
    {
        path: '/exhibitsDetail',
        name: 'exhibitsDetail',
        component: exhibitsDetail,
        meta: {
            title: 'common.detailTitle', //展品详情
            keepAlive: false
        },
    },
    {
        path: '/collection',
        name: 'collection',
        component: collection,
        meta: {
            title: 'exhibits.collection', //征集捐献
            keepAlive: false
        },
    },
    {
        path: '/solicitation',
        name: 'solicitation',
        component: solicitation,
        meta: {
            title: '登记藏品',
            keepAlive: true
        }
    },
    {
        path: '/collectionList',
        name: 'collectionList',
        component: collectionList,
        meta: {
            title: 'exhibits.donationRelics', //文物捐赠
            keepAlive: false
        },
    },
    //************************* */
    //教育活动
    {
        path: '/educationHome',
        name: 'educationHome',
        component: educationHome,
        meta: {
            title: 'menu.educationActivity', //教育活动
            keepAlive: false
        },
    },
    {
        path: '/activityList',
        name: 'activityList',
        component: activityList,
        meta: {
            title: 'menu.edu_latest_activities', //最新活动
            keepAlive: false
        },
    },
    {
        path: '/activityDetail',
        name: 'activityDetail',
        component: activityDetail,
        meta: {
            title: 'activity.details', //活动详情
            keepAlive: false
        },
    },
    {
        path: '/volunteers',
        name: 'volunteers',
        component: volunteers,
        meta: {
            title: 'activity.home', //志愿者主页
            keepAlive: false
        },
    },
    {
        path: '/volunteerActivityList', //志愿者活动列表
        name: 'volunteerActivityList',
        component: volunteerActivityList,
        meta: {
            title: 'activity.volunteers', //志愿者风采
            keepAlive: false
        },
    },
    {
        path: '/volunteerSignUp', //志愿者报名
        name: 'volunteerSignUp',
        component: volunteerSignUp,
        meta: {
            title: 'activity.home', //志愿者之家
            keepAlive: false
        },
    },

    //************************* */
    //问卷调查
    {
        path: '/questionRadio',
        name: 'questionRadio',
        component: questionRadio,
        meta: {
            title: 'questionnaire.title', //问卷调查
            keepAlive: false
        },
    },
    {
        path: '/messageBoard',
        name: 'messageBoard',
        component: messageBoard,
        meta: {
            title: 'home.messageBoard', //留言板
            keepAlive: false
        },
    },
    {
        path: '/policies',
        name: 'policies',
        component: policies,
        meta: {
            title: 'home.policies', //政策法规
            keepAlive: false
        },
    },
    {
        path: '/mailbox',
        name: 'mailbox',
        component: mailbox,
        meta: {
            title: 'home.mailBox', //馆长信箱
            keepAlive: false
        },
    },
    //************************* */
    //学术研究
    {
        path: '/institutions',
        name: 'institutions',
        component: institutions,
        meta: {
            title: 'academic.institutions', //学术机构
            keepAlive: false
        },
    },
    {
        path: '/magazine',
        name: 'magazine',
        component: magazine,
        meta: {
            title: 'academic.book', //学术期刊
            keepAlive: false
        },
    },
    {
        path: '/classroom',
        name: 'classroom',
        component: classroom,
        meta: {
            title: 'academic.classroom', //学术讲堂
            keepAlive: false
        },
    },
   

    //************************* */
    //科技保护
    {
        path: '/unitedStation',
        name: 'unitedStation',
        component: unitedStation,
        meta: {
            title: 'menu.sci_workstation', //联合工作站简介
            keepAlive: false
        },
    },
    {
        path: '/protection',
        name: 'protection',
        component: protection,
        meta: {
            title: 'menu.sci_achievements', //保护修复成果
            keepAlive: false
        },
    },
    {
        path: '/protectionList',
        name: 'protectionList',
        component: protectionList,
        meta: {
            title: 'menu.sci_achievements', //保护修复成果
            keepAlive: false
        },
    },
    {
        path: '/knowledge',
        name: 'knowledge',
        component: knowledge,
        meta: {
            title: 'menu.sci_knowledge', //科普知识
            keepAlive: false
        },
    },
    {
        path: '/knowledgeDetail',
        name: 'knowledgeDetail',
        component: knowledgeDetail,
        meta: {
            title: 'common.detailTitle', //科普知识详情
            keepAlive: false
        },
    },

]